<script>
    import Logo from './Logo.svelte'
    import TopMenu from './TopMenu.svelte'
    import MenuIcon from './MenuIcon.svelte'
    import MainMenu from './MainMenu.svelte'

    import { scrolledDown } from '../../stores'

    let scrolled = false;

    scrolledDown.subscribe(value => {
        scrolled = value;
    });
</script>

<!-- BEGIN OF site header Menu -->
<header class="hh-header header-top { scrolled ? 'scrolled' : '' }">
    
    <Logo />
    
    <TopMenu />
    
    <MenuIcon />
    
</header>
<!-- END OF site header Menu-->